import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type TypeSentiment = 'neutral' | 'positive' | 'negative';

export interface IDetailStreamListEachMetric {
  isModalOpen: boolean;
  metricName: string;
  separationMetricName: 'for' | 'on' | 'none';
  metricValueName: string;
  isUsingDetailStreamTimeFrame: boolean;
  sourceType?: 'ofm' | 'onm' | 'socmed';
  startDate?: Date | string;
  endDate?: Date | string;
  onmClippingId?: string;
  ofmClippingId?: string;
  sentiment?: TypeSentiment[];
  onmMediaList?: string[];
  ofmMediaList?: string[];
  offlineMediaType?: 'print' | 'broadcast';
  includeKeywords?: string[];
  postOwnership?: string[];
  objectIds?: string[];
  peoples?: string[];
  includeClipping?: boolean;
}

export const initialState: IDetailStreamListEachMetric = {
  isModalOpen: false,
  metricName: '',
  separationMetricName: 'none',
  metricValueName: '',
  isUsingDetailStreamTimeFrame: false
};

export const detailStreamListEachMetric = createSlice({
  name: 'detailStreamListEachMetric',
  initialState,
  reducers: {
    reducerOpenModal: (
      state: IDetailStreamListEachMetric,
      action: PayloadAction<IDetailStreamListEachMetric>
    ) => {
      state.metricName = action.payload.metricName;
      state.separationMetricName = action.payload.separationMetricName;
      state.metricValueName = action.payload.metricValueName;
      state.startDate = action.payload.startDate;
      state.endDate = action.payload.endDate;
      state.isUsingDetailStreamTimeFrame =
        action.payload.isUsingDetailStreamTimeFrame;
      state.sourceType = action.payload.sourceType;
      state.onmClippingId = action.payload.onmClippingId;
      state.ofmClippingId = action.payload.ofmClippingId;
      state.sentiment = action.payload.sentiment;
      state.onmMediaList = action.payload.onmMediaList;
      state.ofmMediaList = action.payload.ofmMediaList;
      state.offlineMediaType = action.payload.offlineMediaType;
      state.includeKeywords = action.payload.includeKeywords;
      state.postOwnership = action.payload.postOwnership;
      state.objectIds = action.payload.objectIds;
      state.peoples = action.payload.peoples;
      state.includeClipping = action.payload.includeClipping;
      state.isModalOpen = true;
    },
    reducerCloseModal: (state: IDetailStreamListEachMetric) => {
      state.metricName = initialState.metricName;
      state.separationMetricName = initialState.separationMetricName;
      state.metricValueName = initialState.metricValueName;
      state.startDate = initialState.startDate;
      state.endDate = initialState.endDate;
      state.isUsingDetailStreamTimeFrame =
        initialState.isUsingDetailStreamTimeFrame;
      state.sourceType = initialState.sourceType;
      state.onmClippingId = initialState.onmClippingId;
      state.ofmClippingId = initialState.ofmClippingId;
      state.sentiment = initialState.sentiment;
      state.onmMediaList = initialState.onmMediaList;
      state.ofmMediaList = initialState.ofmMediaList;
      state.offlineMediaType = initialState.offlineMediaType;
      state.includeKeywords = initialState.includeKeywords;
      state.postOwnership = initialState.postOwnership;
      state.objectIds = initialState.objectIds;
      state.peoples = initialState.peoples;
      state.includeClipping = initialState.includeClipping;
      state.isModalOpen = false;
    }
  }
});

export const { reducerOpenModal, reducerCloseModal } =
  detailStreamListEachMetric.actions;

export default detailStreamListEachMetric.reducer;
